import { useState } from "react";
import { makeStyles } from 'tss-react/mui';
import React from "react";
import { Box } from "@mui/material";
import { FileFallback } from "./FileView/FileFallback";

export type ImageProps = {
    url: string,
    name?: string,
    fallback?: React.ReactNode,
    onClick?: () => void,
    onError?: () => void,
    onSuccess?: () => void,
    cursor?: string,
}

export const useStyles = makeStyles()(() => ({
    image: {
        display: "block",
        margin: "auto",
        maxHeight: '100%',
        maxWidth: '100%',
        objectFit: "contain",
    },
}));

export const Image = React.memo(Image_Internal);

function Image_Internal({ url, fallback, name, onClick, onError, onSuccess, cursor }: ImageProps) {

    const { classes } = useStyles();

    const [useFallback, setFallback] = useState(false);

    if (useFallback)  
        return <>{fallback || <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <FileFallback name={name} />
        </Box>}</>;

    return <Box height="100%" display="flex">
        <img
            alt={name}
            src={url}
            onLoad={() => onSuccess && onSuccess()}
            onError={onLoadError}
            onClick={() => onClick && onClick()}
            className={`${classes.image} image`}
            style={cursor ? { cursor } : {}}
        />
    </Box>

    function onLoadError() {
        setFallback(true)
        onError && onError();  
    }
}
